import { Box, Button, FormHelperText, Typography, styled } from "@mui/material";
import React from "react";
import { IWithClassName } from "../../../theme/default.theme";
import Iframe from "react-iframe";

const Acknowledgement = ({ className }: IWithClassName) => {
  const [showChat, setShowChat] = React.useState(false);

  return (
    <Box className={className}>
      <a href="/">
        <img src="/assets/images/logo.png" alt="logo" />
      </a>
      <Typography variant="h3">Welcome to Datazop!</Typography>

      {showChat ? (
        <>
          <FormHelperText>Chat may take few seconds to load</FormHelperText>
          <Iframe
            url="https://tawk.to/chat/65721e9bbfb79148e59b6d86/1hh2sf4ae"
            className="contact-us"
          />
        </>
      ) : (
        <>
          <Typography variant="h6">
            Thanks for creating an account with us! All you need to do now is
            wait up to 24 hours for your account approval. Email might land in
            your spam.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setShowChat(true)}
          >
            Speak with an Account Manager
          </Button>
        </>
      )}

      <Typography component="a" href="/">
        Go To Home
      </Typography>
    </Box>
  );
};

export default styled(Acknowledgement)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  h6: {
    margin: theme.spacing(4, 0),
  },
  ".contact-us": {
    width: "100%",
    maxWidth: 800,
    height: 500,
    border: "none",
  },
}));
